/**
 * Mirror Copy of permission enum in BE - Validator - AiAppMembershipService.ts
 * maintain this copy for permission usage consistency
 */
export enum AiPermissionEnum {
  // READ
  VIEW_AI_APP = 'viewAiApp',
  VIEW_DASHBOARD = 'viewDashboard',

  // UPDATE
  CAN_CHAT = 'canChat',
  CAN_PUBLISH = 'canPublish',

  // DELETE
  DELETE_AI_APP = 'deleteAiApp',

  /**
   * MANAGE - contains CRUD for each sub-modules
   * Can be broken down in to smaller permissions if requirements needed it
   *
   * i.e.
   *    CREATE_SOURCE = 'createSource',
   *    READ_SOURCE = 'readSource',
   *    UPDATE_SOURCE = 'updateSource',
   *    DELETE_SOURCE = 'deleteSource',
   */
  MANAGE_SOURCE = 'manageSource',
  MANAGE_ACTION = 'manageAction',
  MANAGE_CUSTOMIZATION = 'manageCustomization',
  MANAGE_PERMISSIONS = 'managePermissions',
  MANAGE_SETTINGS = 'manageSettings',
  MANAGE_INTEGRATIONS = 'manageIntegrations',
}

export enum PermissionHierachy {
  // SYSTEM_PERMISSION = 'system_permission',
  APP_MEMBER_PERMISSION = 'app_member_permission',
  // APP_GROUP_PERMISSION = 'app_group_permission',
  // APP_GLOBAL_PERMISSION = 'app_global_permission',
}

export interface Membership {
  hierarchy: PermissionHierachy;
  permission: AiPermissionEnum[];
}

export const hasPermission = (
  key: keyof typeof AiPermissionEnum,
  permissions: AiPermissionEnum[]
) => permissions.includes(AiPermissionEnum[key]);
